import { useEffect } from 'react'
import * as Sentry from '@sentry/tanstackstart-react'
import { createFileRoute, type ErrorComponentProps } from '@tanstack/react-router'
import { SchoolRuleDetailClient } from '../components/SchoolRuleDetailClient'
import { prefetchSchoolPolicy, prefetchSchoolGroups } from '../lib/route-prefetch'

function SchoolRuleDetailError({ error }: ErrorComponentProps) {
  useEffect(() => { Sentry.captureException(error) }, [error])
  return (
    <div className="p-8 text-center text-gray-600">
      Failed to load rule.{' '}
      <button onClick={() => window.location.reload()} className="text-brand underline">
        Retry
      </button>
    </div>
  )
}

export const Route = createFileRoute('/school/$schoolId/rules/$policyId')({
  head: () => ({ meta: [{ title: 'School Rule | Unbreakable' }] }),
  beforeLoad: ({ context, params }) => {
    prefetchSchoolPolicy(context.queryClient, params.schoolId, params.policyId)
    prefetchSchoolGroups(context.queryClient, params.schoolId)
  },
  errorComponent: SchoolRuleDetailError,
  component: SchoolRuleDetailPage,
})

function SchoolRuleDetailPage() {
  const { policyId } = Route.useParams()
  return <SchoolRuleDetailClient policyId={policyId} />
}
